import React from 'react';
import { Helmet } from 'react-helmet-async';
import AdminLayout from '../layouts/AdminLayout';
import W2Section from '../components/W2Section';
import { FileText } from 'lucide-react';

const AdminW2Documents = () => {
  return (
    <AdminLayout>
      <Helmet>
        <title>Admin | W2 Documents</title>
      </Helmet>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="py-4">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-semibold text-gray-900">W2 Documents</h1>
            <div className="flex items-center text-primary">
              <FileText className="w-5 h-5 mr-2" />
              <span>View and manage employee W2 documents</span>
            </div>
          </div>
          
          <W2Section />
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminW2Documents; 